module.exports = __webpack_public_path__ + "static/media/OVATO_WHITEPAPER.67b60cc2.pdf";